// 26.1.11 Reflect.ownKeys(target)
var $export = require('./_export');

$export($export.S, 'Reflect', { ownKeys: require('./_own-keys') });



// WEBPACK FOOTER //
// ./~/core-js/modules/es6.reflect.own-keys.js